import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListVideos from '../../components/content/list-videos.component';

const ContentVideosView = () => {
  const pageTitle = 'Analytics / Engagement / Views by Video';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListVideos />
    </AppLayout>
  );
};

export default ContentVideosView;
